import { Box } from '@mui/system';
import { styled as muistyled, Popover, Typography } from '@mui/material';
import styled from 'styled-components';
import { InputItem } from '../../../components/common/InputDropdown';

export const ReportsHeader = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  gap: 24px;
  border-bottom: solid 1px ${({ theme }) => theme.palette.grey[200]};
`;

export const MainTopFilter = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  flex-wrap: wrap;
  padding: 0px;
  gap: 18px;
  width: 100%;
  #datetime-range-modal {
    left: 0;
  }
`;

export const SelectMenuItem = styled(InputItem)`
  svg {
    color: ${({ theme }) => theme.palette.primary[600]};
  }
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 0px;
  padding: 10px 14px;
`;

export const CustomLabels = styled(Typography)`
  margin-bottom: 6px;
  padding: 0;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.grey[700]};
  ${({ theme }) => theme.typography.tsm};
`;

export const TabsChartsWrapper = styled(Box)`
  background-color: ${({ theme }) => theme.palette.grey[100]};
  border: solid 1px ${({ theme }) => theme.palette.grey[200]};
  border-radius: 8px;
  border-color: ${({ theme }) => theme.palette.grey[200]};
  padding: 6px;
  margin-top: 0;
  width: 100%;
`;

export const StyledTabsCharts = styled(Box)`
  min-height: unset;
  overflow: visible;
  height: 44px;

  & .MuiTabs-scroller {
    overflow: visible !important;
    height: 44px;
  }

  & .MuiTabs-root {
    width: 100%;
  }

  & .MuiTab-root {
    padding: 12px 16px;
    border-radius: 6px;
    color: ${({ theme }) => theme.palette.grey[500]};
    font-size: 16px;
    min-height: unset;
    overflow: visible;
  }
  & .MuiTabs-flexContainer {
    gap: 8px;
  }

  & .Mui-selected {
    background-color: ${({ theme }) => theme.palette.base.background};
    color: ${({ theme }) => theme.palette.grey[700]};
    box-shadow: ${({ theme }) => theme.shadows[27]};
  }
  & .MuiTabs-indicator {
    display: none;
  }
  & button {
    flex-grow: 1;
    max-width: unset;
    transition: all 0.2s ease-out;

    :hover {
      background-color: ${({ theme }) => theme.palette.base.background};
      color: ${({ theme }) => theme.palette.grey[700]};
      box-shadow: ${({ theme }) => theme.shadows[27]};
    }
  }
`;


export const StyledPopover = muistyled(Popover)(({ theme }) => ({
  '.PrivateDateRangePickerToolbar-penIcon': {
    display: 'none',
  },
  '.PrivatePickersToolbar-dateTitleContainer': {
    padding: '10px 0',
    button: {
      borderRadius: '8px',
      padding: '10px 15px',
      border: `solid 1px ${theme.palette.grey[300]}`,
    },
    span: {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '1.3',
    },
    div: {
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    },
  },
  '.PrivatePickersSlideTransition-root': {
    minHeight: '230px',
  },
  '.MuiDateRangePickerDay-rangeIntervalDayHighlight': {
    backgroundColor: theme.palette.primary[400],
    '.MuiDateRangePickerDay-rangeIntervalPreview': {
      button: {
        backgroundColor: theme.palette.primary[200],
        '&.Mui-selected': {
          backgroundColor: theme.palette.primary[600],
        },
      },
    },
  },
}));
